import { Dialog, DialogProps } from "@mui/material";
import {
  AdditionalInfo,
  Kind,
  Parameter,
  ParameterDefinition,
} from "../../graphql/generated";
import { ResourceConfigurationView } from "../ResourceConfigForm";
import { ResourceDialogContextProvider } from "./ResourceDialogContext";
import { isFunction } from "lodash";
import { DialogResource } from ".";

interface EditResourceDialogProps extends DialogProps {
  resourceTypeDisplayName: string;
  displayName?: string;
  resourceNameField?: string;
  description: string;
  additionalInfo?: AdditionalInfo | null;
  resourceDocLink?: string;
  onSave: (values: { [key: string]: any }) => void;
  onDelete?: () => void;
  onCancel: () => void;
  parameters: Parameter[];
  parameterDefinitions: ParameterDefinition[];
  includeNameField?: boolean;
  kind: Kind.Source | Kind.Destination | Kind.Processor;
  // The supported telemetry types of the resource type that is
  // being configured.  a subset of ['logs', 'metrics', 'traces']
  telemetryTypes?: string[];
  paused?: boolean;
  onTogglePause?: () => void;
  readOnly?: boolean;
  showLibraryBookmark?: boolean;
  onAddToLibrary?: (values: { [key: string]: any }, name: string) => void;
  libraryResources?: DialogResource[];
}

const EditResourceDialogComponent: React.FC<EditResourceDialogProps> = ({
  displayName,
  resourceNameField,
  onSave,
  onDelete,
  onTogglePause,
  onCancel,
  resourceTypeDisplayName,
  description,
  additionalInfo,
  resourceDocLink,
  parameters,
  parameterDefinitions,
  kind,
  telemetryTypes,
  includeNameField = false,
  paused = false,
  readOnly,
  showLibraryBookmark,
  onAddToLibrary,
  libraryResources,
  ...dialogProps
}) => {
  return (
    <Dialog
      {...dialogProps}
      onClose={onCancel}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: {
          height: "85vh",
        },
      }}
    >
      <ResourceConfigurationView
        includeNameField={includeNameField}
        resourceNameField={resourceNameField}
        includeDisplayNameField={kind === Kind.Source}
        resourceTypeDisplayName={resourceTypeDisplayName}
        displayName={displayName}
        additionalInfo={additionalInfo}
        resourceDocLink={resourceDocLink}
        description={description}
        kind={kind}
        parameterDefinitions={parameterDefinitions}
        parameters={parameters}
        onSave={onSave}
        onDelete={onDelete}
        telemetryTypes={telemetryTypes}
        paused={paused}
        onTogglePause={onTogglePause}
        readOnly={readOnly}
        showLibraryBookmark={showLibraryBookmark}
        onAddToLibrary={onAddToLibrary}
        libraryResources={libraryResources}
      />
    </Dialog>
  );
};

export const EditResourceDialog: React.FC<EditResourceDialogProps> = (
  props,
) => {
  function handleClose() {
    if (isFunction(props.onClose)) {
      props.onClose({}, "backdropClick");
    }
  }
  return (
    <ResourceDialogContextProvider purpose="edit" onClose={handleClose}>
      <EditResourceDialogComponent {...props} />
    </ResourceDialogContextProvider>
  );
};
